import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage, injectIntl } from 'react-intl'

const isCardCompleted = ({ count_current, count_total, countDisputes }) => {
  if (countDisputes) {
    return !(count_current !== count_total || countDisputes !== 0)
  } else if (countDisputes == 0) {
    return true
  }
  return count_current === count_total
}

const getPendingCardCount = ({ count_current, count_total, countDisputes }) => {
  if (!countDisputes) {
    return `${count_current}/${count_total}`
  }
  if (count_total !== count_current) {
    return `${count_current}/${Math.min(countDisputes, count_total)}`
  }
  return `${countDisputes}`
}
const ActionButton = ({
  count_current,
  count_total,
  prizeCoins,
  changeScreen,
  countDisputes,
  antiCoins,
}) => {
  const disabled = isCardCompleted({ count_current, count_total, countDisputes })
  return (
    <div
      className={`btn--shape shape--violet ${disabled ? 'disabled' : ''}`}
      onClick={() => {
        if (!disabled) changeScreen()
      }}
    >
      <div className="btn--shape__canvas">
        <span>
          <FormattedMessage id="mining.actionButton" values={{ gcoins: prizeCoins }} />
          <span className="icon-coin" />
        </span>
        {antiCoins && (
          <span className="color--blue">
            : {antiCoins}
            <span className="icon-antimateria" />
          </span>
        )}
      </div>
    </div>
  )
}
ActionButton.propTypes = {
  count_current: PropTypes.number,
  count_total: PropTypes.number,
  prizeCoins: PropTypes.number,
  changeScreen: PropTypes.func,
  antiCoins: PropTypes.number,
  countDisputes: PropTypes.number,
}

const Card = ({
  changeScreen,
  count_current,
  count_total,
  penalized,
  prizeCoins,
  signalNameId,
  infoTooltip,
  tooltipValue,
  countDisputes,
  showInfo,
  icon,
  hide,
  getDisputesHistory,
  antiCoins,
}) => {
  const disabled = isCardCompleted({ count_current, count_total, countDisputes })
  return (
    <div
      className={`signals--list__item ${showInfo ? 'show--info' : ''} ${
        disabled && !showInfo ? 'disabled' : ''
      }`}
    >
      {!hide && (
        <React.Fragment>
          <div className="signal--front">
            <span className={icon}> </span>
            <div className="signal--type">
              <span>
                <FormattedMessage id={signalNameId} />
              </span>
            </div>
            {signalNameId != 'mining.vote_question' ? (
              <div className="signal--num">
                {getPendingCardCount({ count_current, count_total, countDisputes })}
              </div>
            ) : (
              <React.Fragment>
                <div onClick={() => getDisputesHistory()} className="btn--orange">
                  <span className="icon-doc"></span>
                  <span>
                    <FormattedMessage id="mining.history_dipute" />
                  </span>
                </div>
                <div className="signal--num">{countDisputes}</div>
              </React.Fragment>
            )}
            <ActionButton
              count_current={count_current}
              count_total={count_total}
              prizeCoins={prizeCoins}
              changeScreen={changeScreen}
              countDisputes={countDisputes}
              penalized={penalized}
              antiCoins={antiCoins}
            />
          </div>

          <div className="signal--back">
            <div className="signal--type">
              <span>
                <FormattedMessage id={infoTooltip} values={{ topic: tooltipValue }} />
              </span>
            </div>
            <ActionButton
              count_current={count_current}
              count_total={count_total}
              prizeCoins={prizeCoins}
              changeScreen={changeScreen}
              countDisputes={countDisputes}
              penalized={penalized}
              antiCoins={antiCoins}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

Card.propTypes = {
  changeScreen: PropTypes.func,
  count_current: PropTypes.number,
  count_total: PropTypes.number,
  countDisputes: PropTypes.number,
  icon: PropTypes.string,
  infoTooltip: PropTypes.string,
  penalized: PropTypes.bool,
  prizeCoins: PropTypes.number,
  antiCoins: PropTypes.number,
  showInfo: PropTypes.bool,
  signalNameId: PropTypes.string,
  getDisputesHistory: PropTypes.func,
  tooltipValue: PropTypes.string,
  hide: PropTypes.bool,
}

export default injectIntl(Card)
